import React, { useState, useCallback } from 'react';

import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import Modal from 'buyside/components/presentation/Modal/modal';

import styles from './aboutIntroRequestsModalStyles';

const AboutIntroRequestsModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const renderOpenModalButton = useCallback(
    () => (
      <Button
        className={styles.introRequestsModalLink}
        onClick={() => setIsModalOpen(true)}
        text="More about introduction requests"
        type={BUTTON_TYPES.LINK}
      />
    ),
    []
  );

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      renderOpenModalButton={renderOpenModalButton}
      size="lg"
      title="Introduction Requests"
    >
      <p>
        Cap Intro is constructed as a reverse-solicitation platform, which means that the Allocators
        are responsible for initiating all dialogue. This feature is designed to allow fund managers
        to directly signal their interest in speaking with a specific Allocator that appears to be a
        good fit for the fund. The "Get Introduced" functionality allows fund managers to take a
        proactive role in opening the pathway toward productive communication. These requests
        greatly increase the likelihood of a page visit from the respective Allocator, as well as
        boost the chances of future dialogue.
      </p>
      <p>
        Please keep in mind that the respective institution is never obligated to respond. Instead,
        requesting an introduction will send a notification to the Allocator, and creates a visual
        distinction for your firm's profile that persists until action is taken by the investor. If
        the respective institution agrees to be introduced to you, both firms will receive a
        notification indicating as such.
      </p>
      <p>
        Please consider this feature only if you have serious interest in accepting capital from
        this firm. Abuse of this feature will result in its removal from your fund and/or your
        removal from the platform itself.
      </p>
    </Modal>
  );
};

export default AboutIntroRequestsModal;
